import { BaseFetch } from "../main-model"
export default class ReportTalenModel extends BaseFetch {
    getReportTalenBy = (data) =>
    this.authFetch({
      url: "report-talen/getReportTalenBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
